Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
React = require 'react'
localizeServerError = require 'lib/localize-server-error'
{ maybeDisplayOrgMemberLimitsError } = require 'views/organization/member-limits-error'
t = require('views/internal/recup-with-helpers')('manage_members')
track = require 'debug/track'
_ = require 'underscore'
l = require 'lib/localize'
OrgFeatures = require 'data/org-features'
formatMoney = require 'lib/format/money'

BulkAddOrgMembersView = require 'views/organization/bulk-add-org-members-view-react'
InvitationLink = require './invitation-link'
LinkGoogleApps = require './link-google-apps'
InviteAddName = require './invite-add-name'
MemberList = require './member-list'
Summary = require './summary'

DEBOUNCE_DELAY = 250 #ms
debounce = (fn) -> _.debounce(fn, DEBOUNCE_DELAY)
EMAIL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/

module.exports = class extends React.Component
  displayName: 'ManageOrgMembersComponent'

  constructor: (props) ->
    super(props)

    @state = {
      isSearching: false
      members: null
      searchValue: null
      selectedMembers: []
    }

    { model } = @props

  render: t.renderable ->
    { isSearching, members, searchValue, selectedMembers } = @state
    { model } = @props

    showBillingSummary = model.isBusinessClass() && !model.isPO()
    searchClass = if isSearching then '' else '.hide'
    isEmail = searchValue && EMAIL_REGEX.test(searchValue) && Auth.me().attributes.email != searchValue

    placeholder = l('add member placeholder')
    isPerUser = OrgFeatures.isPerUser(model.get('products'))
    perUserPrice = formatMoney(OrgFeatures.getPrice(model.get('products')))
    isYearly = OrgFeatures.getInterval(model.get('products')) == 'yearly'
    isMonthly = OrgFeatures.getInterval(model.get('products')) == 'monthly'
    canLinkGoogleApps = model.isFeatureEnabled('googleApps') && (!model.get('prefs').associatedDomain || @googleAppsFetchFailed) && model.editable()

    t.div '.add-member-popup.team-members-tab-layout', =>
      t.div '.manage-member-invitation-section', =>
        t.div '.search-with-spinner', =>
          t.h4 ->
            t.icon 'member', 'enter-email-address-or-name'
          t.input '.search-member.js-autofocus', { type: 'text', placeholder, onChange: @onSearchInputChange }
          t.div ".spinner.small#{searchClass}"
          t.p '.u-bottom.quiet.bulk-add-members-copy', =>
            t.format 'big-team'
            t.a '.u-bottom.action-link', { href: '#', onClick: @showBulkAddView }, ->
              t.format 'add-many-people-at-once'

      if members
        if !members.length
          if isEmail
            @renderInviteAddName()
          else
            t.div '.quiet.search-text.no-results', -> t.format 'no-results'
        else
          @renderMemberList()

      if isPerUser
        t.p '.quiet.u-bottom.per-user', ->
          if isMonthly
            t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-month', { jpsPrice: perUserPrice }
          if isYearly
            t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-year', { jpsPrice: perUserPrice }

      @renderInvitationLink()

      t.div '.js-ad'

      if canLinkGoogleApps
        @renderLinkGoogleApps()

      if showBillingSummary && selectedMembers.length
        @renderSummary()
      else
        @renderAddButton()

  renderMemberList: =>
    { members, selectedMembers } = @state

    t.createElement MemberList, { members, selectedMembers, @toggleMember }

  renderInvitationLink: =>
    { model } = @props

    t.createElement InvitationLink, { apiUrl: model.url(), teamUrl: model.get('url'), teamId: model.get('id') }

  renderLinkGoogleApps: =>
    { model, modelCache } = @props
    showBillingSummary = model.isBusinessClass() && !model.isPO()

    t.createElement LinkGoogleApps, { model, modelCache, showBillingSummary }

  renderInviteAddName: =>
    { model, modelCache } = @props
    { searchValue } = @state

    email = searchValue

    t.createElement InviteAddName, { email, model, modelCache }

  renderAddButton: =>
    { selectedMembers } = @state

    selectedMembersCount = selectedMembers.length
    addToTeamButtonClass = if selectedMembersCount then '' else '.disabled'

    t.button ".primary.full#{addToTeamButtonClass}",
      { onClick: @addSelectedMembers, disabled: !selectedMembersCount },
      -> t.format 'add-to-team'

  renderSummary: =>
    { selectedMembers } = @state
    { model } = @props

    selectedMembersCount = selectedMembers.length
    price = model.calculateTotalPrice selectedMembersCount

    if model.isPremiumMonthly()
      subscriptionIntervalKey = 'monthly-subscription'
    if model.isPremiumYearly()
      subscriptionIntervalKey = 'yearly-subscription'

    salesTaxForSubscriberUrl = "#{model.urlRoot}/#{model.id}/paidAccount/salesTaxForSubscriber"

    t.createElement Summary, { @addSelectedMembers, price, salesTaxForSubscriberUrl, selectedMembersCount, subscriptionIntervalKey }

  toggleMember: (idMember) =>
    if @state.selectedMembers.some((id) -> id == idMember)
      selectedMembers = @state.selectedMembers.filter((id) -> id != idMember)
    else
      selectedMembers = [@state.selectedMembers..., idMember]

    @setState { selectedMembers }

  onSearchInputChange: ({ target: { value } }) =>
    @setState selectedMembers: []

    if !value.length
      @setState({ members: null, searchValue: null })
    else
      @searchMembers value

  searchMembers: debounce (searchValue) ->
    searchValue = searchValue.toLowerCase().trim()

    @setState {
      isSearching: true
      searchValue
    }

    ApiPromise
      url: '/1/search/members/'
      type: 'get'
      data:
        idOrganization: @props.model.id
        query: searchValue
      dataType: 'json'
    .then (members) =>
      # if there is no id then it's not really a user it's for inviting a new user when entering an unknown email
      members = _.sortBy members.filter((m) -> m.id), (member) -> member.fullName?.toLocaleLowerCase()

      @setState {
        isSearching: false
        members
      }

  addSelectedMembers: =>
    { members, selectedMembers } = @state
    { model } = @props

    if maybeDisplayOrgMemberLimitsError(@el, model, null)
      return

    selectedMembers.forEach (idMember) =>
      member = members.filter((m) -> m.id == idMember)[0]

      model.addMembers(member)
        .catch ApiError, @_handleError

    PopOver.hide()

  _handleError: (resOrApiError) =>
    message = localizeServerError(resOrApiError)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ resOrApiError.message ? resOrApiError.responseText }")

  showBulkAddView: =>
    { model } = @props

    PopOver.toggle
      elem: @el
      getViewTitle: -> l ['view title', 'add members']
      reactElement: React.createElement BulkAddOrgMembersView, {
        key: 'bulk add members'
        model
      }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/index.coffee